import React, { useContext, useState } from "react";
import {
  Avatar,
  Badge,
  Button,
  Col,
  Dropdown,
  Image,
  Row,
  Space,
  Typography,
} from "antd";
import { Link } from "react-router-dom";

import logo from "../assets/karbonvise-logo.svg";
// import { AuthContext } from "../providers/AuthProvider";
import { capitalize } from "lodash";
import { BellOutlined } from "@ant-design/icons";
import { useGetMeQuery } from "../api/services/suppliers";
import { AuthContext } from "../providers/AuthProvider";

const TopBar = () => {
  const { handleLogout } = useContext(AuthContext);
  const { data: loggedInUser, error } = useGetMeQuery();

  const [open, setOpen] = useState(false);

  const items = [
    {
      key: "1",
      label: (
        <Button block type="ghost" onClick={handleLogout}>
          Logout
        </Button>
      ),
    },
  ];
  // const hasUnreadNotification =
  //   data?.results?.filter((item) => item?.read_at === null)?.length > 0;

  return (
    <Row justify={"center"} align={"middle"} style={{ height: "100%" }}>
      <Col span={22}>
        <Row
          align={"stretch"}
          justify={"space-between"}
          style={{ height: "100%" }}
        >
          <Link to={"/"}>
            <Image src={logo} preview={false} />
          </Link>
          <Space size={"middle"} align="center" direction="horizontal">
            <Button
              type="ghost"
              onClick={() => setOpen(true)}
              // icon={
              //   <Badge dot={hasUnreadNotification}>
              //     <BellOutlined size={"100px"} onClick={() => setOpen(true)} />
              //   </Badge>
              // }
            />
            <Dropdown
              menu={{
                items,
              }}
              placement="bottom"
            >
              <Space size={"middle"} direction="horizontal">
                <Avatar
                  style={{
                    backgroundColor: "#00984A",
                    verticalAlign: "middle",
                  }}
                  size="default"
                >
                  {capitalize(loggedInUser?.email?.charAt(0))}
                </Avatar>
                <Space.Compact size={"small"} direction="vertical" block>
                  <Typography.Text
                    strong
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    {loggedInUser?.email}
                  </Typography.Text>
                  <Typography.Text
                    type="secondary"
                    style={{ fontSize: "12px" }}
                  >
                    {loggedInUser?.full_name}
                  </Typography.Text>
                </Space.Compact>
              </Space>
            </Dropdown>
          </Space>
        </Row>
      </Col>
      {/* <NotificationDrawer
        open={open}
        setOpen={setOpen}
        notifications={data?.results}
      /> */}
    </Row>
  );
};

export default TopBar;
